/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Formik, FormikHelpers } from 'formik';

import { useHistory } from 'react-router-dom';
import { LuCalendarRange, LuUsers } from 'react-icons/lu';

import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';

import api from '../../../../services/api';

import { useToast } from '../../../../hooks/toast';

import {
  DateFilter,
  Field,
  FilterActions,
  FilterStyles,
  Section,
} from '../../../../components/FilterKit';

interface SearchData {
  proc_cod_cliente: number;
  sector: string | string[];
  inCharge: string;
  referenceId: number;
  description: string;
  billedHour: string,
  proc_tipo: string;
  proc_data_ajuiz_inicio: Date;
  proc_data_ajuiz_final: Date;
}

interface IOptions {
  label: string;
  value: string;
  disabled: boolean;
  workingsector: string;
}

const SearchHourPercentageByCustomer:React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const initialValues: SearchData = {
    proc_cod_cliente: 0,
    sector: ['all'],
    inCharge: 'global|0',
    referenceId: 0,
    description: '',
    billedHour: 'A',
    proc_tipo: 'todos',
    proc_data_ajuiz_inicio: new Date(),
    proc_data_ajuiz_final: new Date(),
  };

  const [customerId, setCustomerId] = useState('0');
  const [hourType, setHourType] = useState('todos');
  const [dateFilterType, setDateFilterType] = useState('data');

  const [
    initialRegistrationDate, setInitialRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);
  const [
    finalRegistrationDate, setFinalRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [attorneysOptions, setAttorneysOptions] = useState<IOptions[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [assistantsOptions, setAssistantsOptions] = useState([{}]);
  const [customersOptions, setCustomersOptions] = useState([{}]);
  const [sectorOptions, setSectorOptions] = useState([{}]);

  const validationSchema = null;

  const hourTypeOptions = [
    { name: 'Processo', value: 'processo', style: 'font-size: small;' },
    { name: 'Assessoria', value: 'assessoria', style: 'font-size: small;' },
    { name: 'Todos', value: 'todos', style: 'font-size: small;' },
  ];

  useEffect(() => {
    (async () => {
      await api.get('customers/show/all').then((response) => {
        response.data.map((customer:
        {
          cliente_id: number,
          cliente_nome:string
        }) => (
          customersOptions.push({
            name: customer.cliente_nome,
            value: customer.cliente_id,
          })
        ));
      });
      customersOptions.splice(0, 1);
      setCustomersOptions(customersOptions);
    })();
  }, [customersOptions]);

  useEffect(() => {
    (async () => {
      await api.get('/management/attorneys/show/inchargelawsuits/attorneys').then((response) => {
        if (response.data.length > 0) {
          sectorOptions.push({
            name: 'Todos',
            value: 'all',
          });
          response.data.map((sector: {
            setor_adv: string
          }) => (
            sectorOptions.push({
              name: sector.setor_adv,
              value: sector.setor_adv,
            })
          ));
        }
      });

      await api.get('/management/attorneys/show/inchargelawsuits/others').then((response) => {
        if (response.data.length > 0) {
          response.data.forEach((sector: {
            setor_adm: string
          }) => {
            if (sectorOptions.indexOf(sector.setor_adm) === -1) {
              sectorOptions.push({
                name: sector.setor_adm,
                value: sector.setor_adm,
              });
            }
          });
        }
      });

      sectorOptions.splice(0, 1);
      setSectorOptions(sectorOptions);
    })();
  }, [sectorOptions]);

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>,
  ) => {
    try {
      // const access = JSON.parse(sessionStorage.getItem('@Jurisnet:access') || '{}');
      const access = JSON.parse(localStorage.getItem('@Jurisnet:access') || '{}');

      let menu = '';
      if (access) {
        menu = access.menu;
      }

      const searchFormData = {
        proc_cod_cliente: customerId,
        sector: ['all'],
        inCharge: 'global|0',
        referenceId: 0,
        description: '',
        billedHour: 'A',
        proc_tipo: hourType,
        dateFilterType,
        proc_data_ajuiz_inicio: initialRegistrationDate,
        proc_data_ajuiz_final: finalRegistrationDate,
        menu,
      };

      localStorage.removeItem('@Jurisnet:selectedhour');

      history.push({
        pathname: '/report/hour/percentage',
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ocorreu um problema',
        description:
              'Tente repetir a pesquisa ou contate o administrador.',
      });
    }
  };

  return (
    <FilterStyles>
      <Formik
        onSubmit={handleOnSubmit}
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          handleSubmit,
          handleReset,
        }) => (
          <form className="card search-card" onSubmit={handleSubmit}>
            <header className="search-title">
              <h3>Relatório de Horas e Percentuais por Cliente - Modelo IX</h3>
              <span className="search-hint">Escolha o cliente e o período do relatório.</span>
            </header>

            <div className="search-grid">
              <div className="search-col">
                <Section icon={<LuUsers />} title="Cliente e tipo">
                  <Field id="proc_cliente" label="Cliente">
                    <Dropdown
                      id="proc_cliente"
                      name="proc_cliente"
                      options={customersOptions}
                      onChange={(e) => setCustomerId(e.target.value)}
                      value={customerId}
                      className="inputfield w-full"
                      optionLabel="name"
                      optionValue="value"
                      filter
                      resetFilterOnHide
                      filterBy="name"
                      placeholder="Selecione uma opção"
                      emptyFilterMessage="Nenhum registro encontrado"
                    />
                  </Field>
                  <Field id="proc_tipo" label="Tipo">
                    <SelectButton
                      id="proc_tipo"
                      value={hourType}
                      options={hourTypeOptions}
                      optionLabel="name"
                      onChange={(e) => setHourType(e.value)}
                    />
                  </Field>
                </Section>
              </div>

              <div className="search-col">
                <Section icon={<LuCalendarRange />} title="Período">
                  <DateFilter
                    id="data_registro"
                    label="Data de registro"
                    withMode
                    value={{
                      mode: dateFilterType === 'periodo' ? 'periodo' : 'data',
                      start: initialRegistrationDate instanceof Date ? initialRegistrationDate : null,
                      end: finalRegistrationDate instanceof Date ? finalRegistrationDate : null,
                    }}
                    onChange={(next) => {
                      setDateFilterType(next.mode);
                      setInitialRegistrationDate(next.start);
                      setFinalRegistrationDate(next.end);
                    }}
                  />
                </Section>
              </div>
            </div>

            <FilterActions
              active={[
                customerId !== '0',
                hourType !== 'todos',
                initialRegistrationDate !== null,
                finalRegistrationDate !== null,
              ].filter(Boolean).length}
              submitLabel="Pesquisar processos"
              onClear={() => {
                handleReset();
                setCustomerId('0');
                setHourType('todos');
                setDateFilterType('data');
                setInitialRegistrationDate(null);
                setFinalRegistrationDate(null);
              }}
            />
          </form>
        )}
      </Formik>
    </FilterStyles>
  );
};

export default SearchHourPercentageByCustomer;
